import React, { useState, useEffect } from "react";
import {
  Card,
  Grid,
  FormControlLabel,
  Switch,
  IconButton,
  Popover,
  TextField,
  useTheme,
  makeStyles
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { ThemeType } from "@theme";
import { useTarget } from "@hooks";
import { PrimaryButton, RegularButton, SpinnerOverlay } from "@components";
import { Paragraph } from "@components/typography/Paragraph";
import Avatar from "@components/Avatar";

type Props = {
  value: boolean;
  comment: string;
  save: (unfit: boolean, comment: string) => Promise<void>;
  name?: string;
  noComment?: boolean;
};

export const UnfitItemComponent = ({ value, comment, name, noComment, save }: Props) => {
  const [el, setTarget, clearTarget] = useTarget();
  const [text, setText] = useState(comment);
  const [saving, setSaving] = useState(false);

  useEffect(() => setText(comment), [comment]);
  const classes = useStyles(useTheme());

  const save2 = (unfit: boolean, comment: string) => {
    setSaving(true);
    save(unfit, comment)
      .then(() => {
        setSaving(false);
      })
      .then(clearTarget);
  };

  const open = !!el;
  const isValid = !!text;

  return (
    <Card data-test="Unfit">
      <Grid container item spacing={0} className={classes.grid} xs={12}>
        <SpinnerOverlay show={saving} size={20} />
        <Grid item>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={value}
                disabled={open}
                onChange={value ? () => save2(false, "") : setTarget}
              />
            }
            label={locale.UnfitConsultant}
          />
        </Grid>
        {name && (
          <div
            style={{
              marginTop: "8px",
              marginBottom: "4px",
              width: "100%",
              display: "flex"
            }}
          >
            <Paragraph>
              {noComment && (
                <>
                  {" "}
                  <Avatar size={"small"} name={name} /> {name}
                </>
              )}
            </Paragraph>
          </div>
        )}
        {value && (
          <Grid container justify="space-between" xs={12} style={{ marginTop: "8px" }}>
            <Grid item>
              <Paragraph>
                {locale.Comment}: {text}
              </Paragraph>
            </Grid>
            <Grid item>
              <IconButton onClick={setTarget as any} style={{ bottom: "24%" }}>
                <Edit />
              </IconButton>
            </Grid>
            <Grid item xs={12}></Grid>
          </Grid>
        )}
        <Popover
          anchorEl={el}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ horizontal: "center", vertical: "top" }}
          open={open}
          onClose={clearTarget}
          PaperProps={{ style: { overflow: "initial" } }}
        >
          <Grid item xs={12} className={classes.popoverContent} data-test="UnfitForm">
            <TextField
              value={text}
              onChange={(v) => setText(v.target.value)}
              autoFocus
              fullWidth
              multiline
              label={
                isValid ? locale.FillSomething(locale.Comment) : locale.MissingComment
              }
              error={!isValid}
            />
            <div className={classes.controls}>
              <RegularButton onClick={clearTarget}>{locale.Cancel}</RegularButton>
              <PrimaryButton disabled={!isValid} onClick={() => save2(true, text)}>
                {locale.Save}
              </PrimaryButton>
            </div>
          </Grid>
        </Popover>
      </Grid>
    </Card>
  );
};

const useStyles = makeStyles((theme: ThemeType) => ({
  grid: {
    display: "flex",
    padding: theme.spacing(2),
    paddingTop: 0,
    paddingBottom: 0,
    position: "relative"
  },

  popoverContent: {
    padding: theme.spacing(2),
    minWidth: 300
  },

  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2)
  },

  commentParagraph: {
    marginBottom: theme.spacing()
  }
}));
